    var redirect = "";
    var setRedirect = function(page){
          redirect = page;
    }

    
    
    var array_size = ["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","32","34","36","38","40","34B","36B","38B","40B","42B","34C","36C","38C","40C","42C","32/S","34/M","36/L","38/XL","40/2X","42/3X","3XS","2XS","XS","S","S-M","M","L","L-XL","XL","2XL","2XL-3XL","3XL","4XL","XX","U","2XS/30","XS/30","XS/32","S/32","S/34","M/34","M/36","L/36","L/38","XL/38","XL/40","2XL/40","2XL/42","3XL/42","3XL/44","4XL/46","5XL/48"];

    var assets_url = "//mx.palnegocio.com/cdn/shop/files/color-white.png?v=16138421558872591927";
    assets_url = assets_url.substring(0, assets_url.indexOf("color-white.png"));

    function convertToSlug(text){

        return text.toLowerCase().replace("&",'-').replace("/",'-').replace(/ +/g,'-');
    };

    function alturasIguales(elemento, add_height = 0){

        var altura_elemento_base = 0;

        $(elemento).each(function() {

              $(this).height('auto');
        });

        $(elemento).each(function() {
            if(altura_elemento_base < $(this).height()){
                altura_elemento_base = $(this).height();
            }
        });

        $(elemento).each(function() {
          $(this).height(altura_elemento_base + add_height);
        });
    };

    function ValidPreOrder(tags_customer, sku){

        var min_ven = "";

        if( sku.indexOf("FAJASSALOME") != -1 ){

            var aux_sku = sku.replace("FAJASSALOME","SAL");  
            sku = aux_sku;
        }

        if (sku.indexOf("-") == true ){

            min_ven = "PRE_" + sku.slice(0, sku.indexOf("-"));
        }
        else{

            min_ven = "PRE_" + sku.slice(0, 3);
        }

        var valid = false;

        for (var i = tags_customer.length - 1; i >= 0; i--) {

            if (tags_customer[i] == min_ven){

                valid = true;
                break;
            }
        }
        return valid;
    };
	
	function ValidDescuento(tags_customer, sku, price, color){
		 	
   		if ( typeof price != "number"){
              
    		price = price.toString().replace(".","");
   		}
   		else{
              
    		price = Math.round(price);
    	}
          
        if( sku.indexOf("FAJASSALOME") != -1 ){

            sku = sku.replace("FAJASSALOME","SAL");  
        }
        var brand = "";
        var num_ref = "";

       	if ( sku.indexOf("-") != -1 ){

           	var arr_sku = sku.split("-");
				
          	if( arr_sku[0].indexOf("MYD") != -1 && arr_sku[arr_sku.length - 1].indexOf("pack") != -1 ){
              		
              	brand = arr_sku[0].slice(0, 3);
              	if( arr_sku[0].indexOf("EX") != -1 ){
                  		
                  	num_ref = arr_sku[0].replace(brand, "").slice(0, 5);	
              	}
              	else{
                    
                  	num_ref = arr_sku[0].replace(brand, "").slice(0, 4);
               	}
                  	
           	}
          	else if( arr_sku.length == 2 ){
              
              brand = arr_sku[0].slice(0, 3);
              num_ref = arr_sku[0].replace(brand, "").slice(0, 6);
              
            }
           	else{
					
               	var aux_sku = "";
                  
               	for ( var i = 0; i <= arr_sku.length - 1; i++ ){
                    
                   	if( i > 0 ){
                        
                     	var num_ref_limit = arr_sku.length - 3
                            
                        	if( color == false ){
                            	
                           	num_ref_limit = arr_sku.length - 2;
                        	}
                          	
                       	if( i <= num_ref_limit ){
                  				
                            	aux_sku += arr_sku[i];
                              	
                           	if( i < num_ref_limit ){
                              
                            	aux_sku += "-";	
                           	}
                        }
                    }
                }    
                  	
               	brand = arr_sku[0];
               	num_ref = aux_sku;
           	}
              
       	}
       	else{

           	brand = sku.slice(0, 3);
           	num_ref = sku.replace(brand, "").slice(0, 4);
       	}

        var tag_desc_brand  = "DSC_" + brand;
        var tag_desc_numref = "DSC_" + brand + num_ref;

        var arr_tag_descuento = [];
        var descuento = 0;

       	for (var i = 0; i <= tags_customer.length - 1; i++) {

         	if( tags_customer[i].indexOf("FAJASSALOME") != -1 ){

             	var aux_tag = tags_customer[i].replace("FAJASSALOME","SAL"); 
             	tags_customer[i] = aux_tag;
         	}
         	if (tags_customer[i].indexOf(tag_desc_brand) != -1){

                arr_tag_descuento.push(tags_customer[i]);
           	}
      	}

        var aux_descuento = "";
        var tag_descuento1 = "";
        var tag_descuento2 = "";

        for (var i = 0; i <= arr_tag_descuento.length - 1; i++) {

       		aux_descuento = arr_tag_descuento[i].split("_")[2];
       		tag_descuento1 = tag_desc_brand + "_" + aux_descuento;
       		tag_descuento2 = tag_desc_numref + "_" + aux_descuento; 
          
            if( arr_tag_descuento[i] == tag_descuento1 || arr_tag_descuento[i] == tag_descuento2 ){

                descuento = parseInt(aux_descuento) / 100;
                descuento = ( (100 - descuento) / 100 ) * (parseInt(price.toString().split(".")[0]) / 100) ;
                descuento = (descuento * 100) / 100;

                if(descuento.toString().split(".").length > 1){

                    if(descuento.toString().split(".")[1].length > 1){

                        descuento = descuento.toString().split(".")[0] + "." + descuento.toString().split(".")[1].substring(0, 2);
                    }
                    else{

                        descuento = descuento.toString().split(".")[0] + "." + descuento.toString().split(".")[1].substring(0, 2) + "0";
                    }
                }
                else{

                    descuento = descuento.toString() + ".00";
                } 

                if( arr_tag_descuento[i] == tag_descuento2 ){

                    break;
                }
            } 
       	}
        return descuento;
	};
      	
    function OnlyPreOrder(tags_product){
      		
    	var pre_order = false;
          	
     	for (var i = tags_product.length - 1; i >= 0; i--) {

        	if (tags_product[i] == "PREORDER"){
				console.log('preorder true');
                pre_order = true;
                break;
           	}
       	}
        return pre_order;
   	}
     
    function ValidStockMax(tags_product){
      		
    	var stock_max = 0;
          	
     	for (var i = tags_product.length - 1; i >= 0; i--) {

        	if (tags_product[i].indexOf("max_") >= 0 ){

                stock_max = parseInt( tags_product[i].replace("max_", "") );
                break;
           	}
       	}
        return stock_max;
   	}

	function ValidShowProduct(sold_out, tags_customer, vendor, tags, sku){
		
      	var show_product = false;
      
      	var only_preorder = OnlyPreOrder(tags);
        console.log(only_preorder);
 		var pre_order = ValidPreOrder(tags_customer, sku);
  
		var valid_product_GOR = false;
        if( tags_customer.join().indexOf("DSC_GOR") != -1 ){

          	valid_product_GOR = true;
        }

        if( !(sold_out == true && only_preorder == false && pre_order == false) ){

        	if( !(valid_product_GOR == false && vendor == "Gorgeous VIP") ){
          		
              	show_product = true;
          	}
       	}
      	
      	return show_product;
    }

    function Select_variant(table_content, swatch, swatches){

      var table_data = table_content + " .table." + $(swatch).data("table");
      $(swatches).removeClass("active");
      $(swatch).addClass("active");
      $(table_content).removeClass("show-table").removeClass("fadeIn").addClass("hide-table").addClass("fadeOut");
      $(table_content).addClass("none-table");

      if($(table_data).parent(".table-product-variants").hasClass("hide-table")){

          $(table_data).parent(".table-product-variants").removeClass("none-table");
          $(table_data).parent(".table-product-variants").removeClass("hide-table").removeClass("fadeOut").addClass("show-table").addClass("fadeIn");	                                               
      }
    }

    function Actualizar_subtotal(form, input_cant, table_select, pre_order, product_moq, only_preorder, container_result, template){

        var inputs_quantity = $(container_result + " input[type=number].quantity");
        var inputs_preorder = $(container_result + " input[type=number].pre-order");
        var sub_total = 0;
        var items_cart = 0;
        var items_preorder = 0;
        var input_val = $(input_cant).val();
        var qty = 0;
        var stock = 99999999999999999999;
        if( $(input_cant).hasClass("quantity") == true ){

            stock = $(input_cant).data("stock");
            qty = stock - input_val;
          
            
        }
        if( isNaN(input_val) || input_val == ""){

            input_val = 0;
        }
        $(input_cant).val(parseInt(input_val));

        if( $(input_cant).hasClass("quantity") == true ){

          var preorder = $(input_cant).parent().parent().parent().find("td[data-title=PreOrder] input");

          if( stock >= 0 ){
               
              var stck = $(input_cant).parent().parent().parent().find(".stock span");

              if ( (qty > 0 && product_moq != 0) || (qty > 0 && qty <= stock && product_moq == 0) ) {

                  if(product_moq == 0){
                    

                      stck.text(qty.toString());
                  }

                  if(stck.hasClass("red")){

                      stck.removeClass("red");
                  }
                  preorder.val(0);
                  preorder.attr("disabled", "disabled");  	
              }
              else{
                  if(product_moq == 0){

                    stck.text("0");

                    if(!stck.hasClass("red")){

                        stck.addClass("red");
                    }
                    $(input_cant).val(stock);
                    
                    preorder.removeAttr("disabled");
                  }
              }
          }
          for (var n = 0; n < inputs_quantity.length; n++) {

              sub_total      += parseInt(inputs_quantity[n].value) * parseInt(inputs_quantity[n].dataset.price);
              items_cart     += parseInt(inputs_quantity[n].value);

              if(pre_order == true){

                  items_preorder += parseInt(inputs_preorder[n].value);
              }
          }
          if( product_moq != 0 && template != "buy-again" ){

              preorder.attr("disabled", "disabled");  
              var itms = $(input_cant).parents(form).find(".modal-foot #items_cart span");

              if(items_cart < product_moq){

                  $(form).find(':input[type="submit"]').prop('disabled', true);
                  $(form).find(':input[type="submit"]').hide();

                  if(!itms.hasClass("red")){

                      itms.addClass("red");
                  }
              }
              else{
                  if( isNaN(items_cart) || items_cart == ""){

                      items_cart = 0;
                  }

                  $(form).find(':input[type="submit"]').prop('disabled', false);
                  $(form).find(':input[type="submit"]').show();

                  if(itms.hasClass("red")){

                      itms.removeClass("red");
                  }
              }
          }

        }
        else{
          if( pre_order == false ){

              $(form + " input[type=number].pre-order").val(0);
          }

          var total_stock = 0;
          for (var n = 0; n < inputs_quantity.length; n++) {

              sub_total      += parseInt(inputs_quantity[n].value) * parseInt(inputs_quantity[n].dataset.price);
              items_cart     += parseInt(inputs_quantity[n].value);

              total_stock    += parseInt($(inputs_quantity[n]).attr("data-stock"));
				
              if(pre_order == true){

                  items_preorder += parseInt(inputs_preorder[n].value);
              }
          }
          if( only_preorder == true && template != "buy-again" && total_stock == 0 ){
            

              var itms = $(input_cant).parents(form).find(".modal-foot #items_cart span");

              if(items_preorder < 12){
                  $(form).find(':input[type="submit"]').prop('disabled', true);
                  $(form).find(':input[type="submit"]').hide();

                  if(!itms.hasClass("red")){

                      itms.addClass("red");
                  }
              }
              else{
                  if( isNaN(items_cart) || items_cart == ""){
                      items_cart = 0;
                  }
                  $(form).find(':input[type="submit"]').prop('disabled', false);
                  $(form).find(':input[type="submit"]').show();

                  if(itms.hasClass("red")){

                      itms.removeClass("red");
                  }
              }
          }
        }

        $(container_result).find(".modal-foot #items_cart span").text(items_cart.toString());
        $(container_result).find(".modal-foot #items_preorder span").text(items_preorder.toString());

        var str = sub_total.toString();
        var str2 = "$ " + str.substr(0, str.length - 2) + "." + str.slice(-2);

        $(container_result).find(".modal-foot #total span").html(str2);

        var hide_pre_order  = " style='display: none;' ";

        if(pre_order == true){

            hide_pre_order  = " ";
        }
      
        if( ( parseInt( $(input_cant).val() ) > 0 ) || ( items_cart >= product_moq && product_moq > 0 ) || ( only_preorder == true && items_preorder >= 12 ) ){

          	if(( items_cart < product_moq && product_moq > 0 ) || ( only_preorder == true && items_preorder < 12 )){
          		
              	$(table_select + " tbody").empty();
          	}
          	else{
                $(inputs_quantity).each(function(){

                    var quantity_value = parseInt( $(this).val() );
                    var preorder_value = parseInt( $("input[data-id="+ $(this).data("id") +"].pre-order").val() );
                    var tr_select_movil  = $(table_select + " tbody").find("tr[data-variant=movil-"+ $(this).data("id") +"]");
                    var tr_select        = $(table_select + " tbody").find("tr[data-variant="+ $(this).data("id") +"]");

                    if( items_cart < product_moq ){

                        quantity_value = 0;
                    }
                    if( only_preorder == true && items_preorder < 12 ){
							
                        preorder_value = 0;
                    }
                  
                    if( quantity_value > 0 || preorder_value > 0 ){

                        if( tr_select.length > 0 ){

                            tr_select.find("td.quantity2").empty();
                            tr_select.find("td.quantity2").append( quantity_value );
                            tr_select.find("td.pre-order2").empty();
                            tr_select.find("td.pre-order2").append( preorder_value );
                        }
                        else{

                            $(table_select + " tbody").append("<tr data-variant='movil-"+ $(this).data("id") +"' class='movil-row'>" +
                                                                    "<td data-title='sku' colspan='4'><strong>SKU: </strong>"+ $(this).data("listsku") +"</td>" +
                                                              "</tr>" +
                                                              "<tr data-variant='"+ $(this).data("id") +"'>" +
                                                                    "<td>" + $(this).data("listsku") + "</td>" +
                                                                    "<td>" + $(this).data("listprice") + "</td>" +
                                                                    "<td class='quantity2'>" + quantity_value + "</td>" +
                                                                    "<td" + hide_pre_order + "class='pre-order2'>" + preorder_value + "</td>" +
                                                              "</tr>");
                        }
                    }
                });
            }
        }
        else{
          	if( items_cart < product_moq ){
          		
              	$(table_select + " tbody").empty();
          	}
          	else if( only_preorder == true && items_preorder < 12 ){
            
              	if( total_stock == 0 ){
              		
                  	$(table_select + " tbody").empty();
              	}
              	else{

                    $(inputs_quantity).each(function(){
						
                      	var quantity_value = parseInt( $(this).val() );
                        var tr_select_movil  = $(table_select + " tbody").find("tr[data-variant=movil-"+ $(this).data("id") +"]");
                        var tr_select        = $(table_select + " tbody").find("tr[data-variant="+ $(this).data("id") +"]");

                        if( tr_select.length > 0 ){

                            if( quantity_value > 0 ){

                                tr_select.find("td.pre-order2").empty();
                                tr_select.find("td.pre-order2").append( 0 );
                            }
                          	else{
                          		tr_select_movil.remove();
                              	tr_select.remove();
                          	}
                        }
                    });
              	}
          	}
          	else{
            	
              	$(inputs_quantity).each(function(){

                    var quantity_value = parseInt( $(this).val() );
                    var preorder_value = parseInt( $("input[data-id="+ $(this).data("id") +"].pre-order").val() );
                    var tr_select_movil  = $(table_select + " tbody").find("tr[data-variant=movil-"+ $(this).data("id") +"]");
                    var tr_select        = $(table_select + " tbody").find("tr[data-variant="+ $(this).data("id") +"]");

                    if( tr_select.length > 0 ){
						
                      	if( ( quantity_value == 0 || isNaN( quantity_value ) ) && ( preorder_value == 0 || isNaN( preorder_value ) ) ){

                            tr_select_movil.remove();
                            tr_select.remove();
                      	}
                      	else{
                        	
                             tr_select.find("td.quantity2").empty();
                             tr_select.find("td.quantity2").append( quantity_value );
                             tr_select.find("td.pre-order2").empty();
                             tr_select.find("td.pre-order2").append( preorder_value );
                        }
                    }
                });
              	
            }
        }
      
        var items_total = items_cart + items_preorder;
      
        if( items_total > 0  ){

            $(container_result).find(".add_to_cart").removeClass("disabled-btn");
        }
        else{

            $(container_result).find(".add_to_cart").addClass("disabled-btn");
        }
    };

    function Submit_form_product(container_principal, table_variants, table_select, modal_result, template) {

        if($(container_principal).find("input[type=submit]").hasClass("disabled-btn") == false){

          var qty_cart = 0;
          var qty_preorder = 0;

          if(template == "quick-order" || template == "buy-again"){

              $("section.atc-banner--container").find(".atc--product").remove();
          }
          $.ajax({
                  type: 'GET',
                  url: '/cart.js',
                  async: false,
                  dataType: 'json',
                  success: function(data) {

                      var title = "";
                      var image = "";
                      var construct_cart = "";
                      var construct_preorder = "";
                      var total_qty_cart = 0;
                      var total_qty_preorder = 0;

                      $(table_variants).each( function(){

                          var id_product = $(this).attr("class").replace("table-variants table-","");

                          var products_container = 	'<div class="atc--product .product-'+ id_product +'">' +
                                                          '<div class="atc--product-image" data-atc-banner-product-image>' +
                                                              '<img>' +
                                                          '</div>' +
                                                          '<div class="atc--product-details unique-list">' +
                                                              '<h3 class="atc--product-details--title" 			data-atc-banner-product-title></h3>' +
                                                              '<div class="atc--product-details--container-list">' +
                                                                  '<div class="atc--product-details--list-cart" 		data-atc-banner-product-list-cart></div>' +
                                                                  '<div class="atc--product-details--list-preorder" 	data-atc-banner-product-list-preorder></div>' +
                                                              '</div>' +
                                                          '</div>' +
                                                      '</div>';
                          products_container = $.parseHTML(products_container);
                          var qty_cart = 0;
                          var qty_preorder = 0;
                          var table = "." + $(this).attr("class").split(" ").join(".");
                          var input_item = $(table + " input[type=number]").filter( function(){ return $(this).val() != 0; } );
                          var total_cart = 0;
                          var total_preorder = 0;
                          var count_input_cart = 0;
                          var count_input_preorder = 0;
                          var product_moq = parseInt($(".moq-"+ id_product).val());
                          var only_preorder = JSON.parse($(".preorder-"+ id_product).val());
                          var product_container_id = "#" + $(this).attr("class").replace("table-variants table","product");

                          for (var n = 0; n < input_item.length; n++) {

                              if( $(input_item[n]).hasClass("quantity") == true ){

                                  total_cart += parseInt(input_item[n].value);
                                  count_input_cart += 1;
                              }
                              if( $(input_item[n]).hasClass("pre-order") == true ){

                                  total_preorder += parseInt(input_item[n].value);
                                  count_input_preorder += 1;
                              }
                          }

                          if( template == "quick-order" ){

                              title = $(".product-title").text();
                              image = $(".product-image-container img").attr("src");
                          }
                          if( template == "buy-again" ){

                              title = $(product_container_id).find(".product-title").text();
                              image = $(product_container_id).find(".product-image-container img").attr("src");
                          }
                          $(products_container).find('[data-atc-banner-product-image]').empty().html('<img src="' + image + '" alt="' + title + '">');
                          $(products_container).find('[data-atc-banner-product-title]').empty().html(title);

                          var construct_list =	'<div class="swatch_options" data-product-options-container="">' +
                                                      '<div class="form-options js-required">' +
                                                          '<div class="option-header">' + 
                                                              '<span class="option-name"></span>' +
                                                          '</div>' +
                                                          '<div class="option-values"></div>' +
                                                      '</div>' +
                                                  '</div>';

                          construct_list = $.parseHTML( construct_list );

                          var construct_cart = $(construct_list).clone();
                          var construct_preorder = $(construct_list).clone();

                          $(construct_cart).find(".option-header span").text("Articulos del Carrito");

                          if( count_input_cart > 0 && total_cart < product_moq ){

                              $(construct_cart).find(".option-header").addClass('error');
                          }

                          $(construct_cart).find(".option-header").append('<i class="fas fa-shopping-cart icon-title color-blue"></i>');
                          $(construct_cart).find(".option-header").append('<i class="fas fa-exclamation-triangle icon-title color-blue"></i>');

                          $(construct_preorder).find(".option-header span").text("Articulos de Pre-orden");

                          if( count_input_preorder > 0 && only_preorder == true && total_preorder < 12 ){

                              $(construct_preorder).find(".option-header").addClass('error');
                          }

                          $(construct_preorder).find(".option-header").append('<i class="fas fa-clipboard-check icon-title color-blue"></i>');
                          $(construct_preorder).find(".option-header").append('<i class="fas fa-exclamation-triangle icon-title color-blue"></i>');

                          if( count_input_cart > 0 && total_cart < product_moq ){

                              $(construct_cart).find(".option-values").append('<h4>Los productos seleccionados ( <span>'+ total_cart +'</span> ) no cumplen con la cantidad MOQ de '+ product_moq +' unidades</h4>');
                          }

                          if( count_input_preorder > 0 && only_preorder == true && total_preorder < 12 ){

                              $(construct_preorder).find(".option-values").append('<h4>The selected products ( <span>'+ total_preorder +'</span> ) no cumplen con la cantidad de pre-orden requerida de 12 unidades</h4>');
                          }
                          for (var n = 0; n < input_item.length; n++) {

                              var item_color = input_item[n].dataset.color;
                              var valid_color = "";
                              var item_size = input_item[n].dataset.size;

                              if(item_color == "false"){

                                  item_color = "white";
                                  valid_color = " no-color"
                              }

                              var construct_row = '<div class="row-item" data-variant="'+ input_item[n].dataset.id +'">' +
                                                      '<div class="option-value swatch-element color '+ convertToSlug(item_color) +'-swatch available'+ valid_color +'" data-value="'+ item_color +'" data-table="'+ convertToSlug(item_color) +'-swatch">' +
                                                          '<div class="option-value-label"></div>' +
                                                          '<label for="swatch-1-'+ convertToSlug(item_color) +'" style="background-image: url('+ assets_url + 'color-' + convertToSlug(item_color) +'.png); background-position: center;"></label>' +
                                                      '</div>' +
                                                      '<div class="option-value">' +
                                                          '<label class="option-value-label">' +
                                                              '<input class="option-value-input" type="radio" name="Size" value="'+ item_size +'" tabindex="0" aria-label="'+ item_size +'" checked="">' +
                                                              '<span class="option-value-name">'+ item_size +'</span>' +
                                                          '</label>' +
                                                      '</div>' +
                                                      '<div class="option-value">' +
                                                          '<label class="option-value-label">' +
                                                              '<i class="fas fa-angle-right icon-angle-items"></i>' +
                                                              '<span class="option-value-qty">Cant: <span class="color-blue">'+ parseInt(input_item[n].value) +'</span></span>' +
                                                          '</label>' +
                                                      '</div>' +
                                                  '</div>';

                              if( $(input_item[n]).hasClass("quantity") == true && total_cart > product_moq ){

                                  var item_cart = { 	
                                      id: 		input_item[n].dataset.id, 
                                      quantity: 	input_item[n].value 
                                  };

                                  $.ajax({
                                      type: 'POST',
                                      url: '/cart/add.js',
                                      data : item_cart,
                                      async: false,
                                      dataType: 'json',
                                      success: function(results) {

                                          qty_cart += parseInt(input_item[n].value);
                                          $(construct_cart).find(".option-values").append(construct_row);
                                      },
                                      error: function(err){
                                        console.log(err);
                                      }
                                  }); 
                              }
                              if( $(input_item[n]).hasClass("pre-order") == true && !( only_preorder == true && total_preorder < 12 ) ){

                                  var item_preorder = {	
                                      id: input_item[n].dataset.id, 
                                      sku: input_item[n].dataset.listsku, 
                                      preorder: input_item[n].value,
                                      customer_id: cust_id,
                                      cart_id: data.token,
                                      shop: 2
                                  };
                                  $.ajax({
                                      type: 'POST',
                                      url: 'https://utils.2becommerce.com/add/preorder',
                                      data : item_preorder,
                                      async: false,
                                      dataType: 'json',
                                      success: function(data) { 

                                          console.log( item_preorder );
                                          qty_preorder += parseInt(input_item.value);
                                          $(construct_preorder).find(".option-values").append(construct_row);
                                          let data_notify = { 
                                              name: data.name, 
                                              customer_id: data.customer_id, 
                                              country: data.country, 
                                              sku: data.products.sku, 
                                              qty: data.products.qty 
                                          };
                                          /*
                                          $.ajax({
                                              type: 'POST',
                                              url: 'https://comercialesmx.palnegocio.com/api/preorder-notification',
                                              data : JSON.stringify( data_notify ),
                                              async: true,
                                              contentType: 'application/json',
                                              dataType: "json",
                                              success: function(data) { 

                                                  console.log(data);
                                              },
                                              error: function(err){ 
                                                  console.log("Error:", err);
                                              }
                                          });
                                          */
                                      },
                                      error: function(err){ 
                                        console.log("Error:");
                                        console.log(err);
                                      }
                                  });
                              }
                          }

                          total_qty_cart += qty_cart;
                          total_qty_preorder += qty_preorder;

                          var class_product = $(this).attr("class").replace("table-variants table","product");

                          $(products_container).find('[data-atc-banner-product-list-cart]').hide();
                          $(products_container).find('[data-atc-banner-product-list-preorder]').hide();

                          if( qty_cart > 0 || ( count_input_cart > 0 && total_cart < product_moq ) ){

                              $(products_container).find('[data-atc-banner-product-list-cart]').show();
                              $(products_container).find('[data-atc-banner-product-list-cart]').empty().append(construct_cart);
                          }
                          if( qty_preorder > 0 || ( count_input_preorder > 0 && only_preorder == true && total_preorder < 12 ) ){

                              $(products_container).find('[data-atc-banner-product-list-preorder]').show();
                              $(products_container).find('[data-atc-banner-product-list-preorder]').empty().append(construct_preorder);
                          }

                          $(products_container).find('[data-atc-banner-product-list-cart]').removeClass("unique-list");
                          $(products_container).find('[data-atc-banner-product-list-preorder]').removeClass("unique-list");

                          if( qty_cart > 0 && qty_preorder == 0 && !( count_input_preorder > 0 && only_preorder == true && total_preorder < 12 ) ){

                              $(products_container).find('.atc--product-details').addClass("unique-list");
                              $(products_container).find('[data-atc-banner-product-list-cart]').addClass("unique-list");
                          }
                          else if( qty_cart == 0 && qty_preorder > 0 && ( count_input_cart > 0 && total_cart >= product_moq ) ){

                              $(products_container).find('.atc--product-details').addClass("unique-list");
                              $(products_container).find('[data-atc-banner-product-list-preorder]').addClass("unique-list");
                          }
                          $(products_container).find(" > div").removeAttr("style");
                          $(products_container).find(".atc--product-details > div").removeAttr("style");
                          $(products_container).find(".atc--product-details > div .option-values").removeAttr("style");

                          if( qty_cart > 0 || qty_preorder > 0 ){

                              $(".atc-container--product").append(products_container);
                          }	

                          alturasIguales(class_product + ".atc--product-details > div .option-values", 0);

                          Restore_product("form .add_to_cart",".table-variants.table-"+ id_product +" .table-product-variants table",".product-selected tbody",".results-table-select", product_moq, template, only_preorder);

                      });

                      if(total_qty_cart > 0){

                          $("section.atc-banner--container").find('[data-atc-banner-product-total-cart] h3').empty().html('Articulos del Carrito:<span class="total-items">'+ total_qty_cart +'</span>');
                      }
                      if(total_qty_preorder > 0){

                          $("section.atc-banner--container").find('[data-atc-banner-product-total-preorder] h3').empty().html('Articulos Preordenados:<span class="total-items color-blue">'+ total_qty_preorder +'</span>');
                          $("section.atc-banner--container").find('[data-atc-banner-product-note-preorder] h3').empty().html("<small>Nota: Se le notificará cuando los artiulos <strong class='color-gold'>preordenados</strong> estén disponibles.</small>");
                      }

                      $("section.atc-banner--container").attr("data-flyout-active", "true");
                      $("section.atc-banner--container").attr("tabindex", "-1");

                      if( template == "quick-order" ){

                          $("section.atc-banner--container").css("top", 148);
                      }
                      if( total_qty_cart > 0 || total_qty_preorder > 0 ){

                          $("section.atc-banner--container").find('.atc-banner--outer').addClass("unique-list");
                          $("section.atc-banner--container").find('.atc--product-total-items').addClass("unique-list");
                          $("section.atc-banner--container").find('.atc-banner--cart').addClass("unique-list");

                          $("section.atc-banner--container").addClass("visible");
                          $("section.atc-banner--outer").append("<script>$(document).ready(function(){ setTimeout(function(){ $('.atc-banner--container.visible').remove(); }, 8000); });</script>");       
                      }

                  },
                  error: function(err){
                      console.log(err);
                  }
          });
        }
    };

    function Restore_product(btn_add_to_cart, table_variants, table_select, modal_result, product_moq, template, only_preorder){

      if( template == "quick-order" || template == "buy-again" ){

          $.ajax({
              type: 'GET',
              url: '/cart.js',
              dataType: 'json'
          }).done(function (response) {

              if( response.item_count > 0 ){

                  $("section.atc-banner--container").find('[data-atc-banner-cart-button]').find('span').text(response.item_count);
                  $(".site-header-cart--count").attr("data-header-cart-count", response.item_count);
                  $(".site-header-cart--count").addClass("visible");
              }
          });
      }

      var total_stock = 0;

      $(table_variants).each(function(){

        $(this).children("tbody").children("tr").each(function(){

              $(this).children("td[data-title='PreOrder']").children("div").children("input").val(0);  	
              $(this).children("td[data-title='PreOrder']").children("div").children("input").attr("disabled", "disabled"); 

              var stock = parseInt($(this).children("td[data-title='Order']").children("div").children("input").attr("data-stock"));
			  
              total_stock += stock;

          	  if( product_moq > 0 ){
          		   
              	  stock = "MOQ";
              }
          
              var class_stock = "";

              if( stock == 0 ){ 

                  class_stock = "red"; 
                  $(this).children("td[data-title='PreOrder']").children("div").children("input").removeAttr("disabled");  
              }
              $(this).children("td[data-title='Stock']").empty().append("[ <span class='"+ class_stock +"'>"+ stock +"</span> ]");
              $(this).children("td[data-title='Order']").children("div").children("input").val(0);
        });
      });

      $(table_select).empty();

      $(modal_result + " #items_cart span").text("0")
      $(modal_result + " #items_cart span").removeClass("red");
      $(modal_result + " #total span").text("$ .0");
      $(btn_add_to_cart).prop('disabled', false).show();

      if( product_moq != 0 || ( total_stock == 0 && only_preorder == true && template != "buy-again") ){

          $(btn_add_to_cart).prop('disabled', true).hide();
          $(modal_result + " #items_cart span").text("0").addClass("red");
      }
    };

    function Height_table(window_width, table_variant){

      var height_table = $(table_variant).data("height");

      if(window_width <= 633){
          $(table_variant).css("min-height", height_table * 2);
      }
      else{
          $(table_variant).css("min-height", height_table);  
      }
    };

    function Wholesale_order(customer_tags, customer_id, cart_note, cart_cupon){

      var total = $(".cartitems .cart-item").length;
      var array_items = [];
      var oItem = {};

      $(".cartitems .cart-item").each(function(){
          var oItem = {
            "variant_id":$(this).attr("data-cartitem-id"),
            "sku":$(this).attr("data-cartitem-sku"),
            "qty":$(this).find("input").val(),
            "price":$(this).attr("data-cartitem-price"),
            "price_desc":$(this).attr("data-cartitem-price-desc")
          }
          array_items.push(oItem);
      });

      var data = {
        "customer_tags": customer_tags,
        "customer_id": customer_id,
        "discount": $(cart_cupon).val(),
        "cart_note": $(cart_note).val(),
        "products": array_items
      }; 

      console.log(data);
      $(".container-error").hide();
      $("p .text-error").empty();

      $.ajax({
              type: "POST",
              url: "https://utils.2becommerce.com/plnmx/create/order",
              data: {"data" : JSON.stringify(data)},
              success: function(result){
                  if(result && result.url != null){

                      window.location.replace(result.url);
                  }else{

                      $(".container-error").show();
                      console.log(result.error);
                      $("p .text-error").text(JSON.stringify(result.error));
                  }
              },
              error: function(data){

                  console.log(data);
                  $(".container-error").show();
                  $("p .text-error").text("An error has occurred try again");
              },
              failure: function(errMsg) {

                  console.log(errMsg);
                  $(".container-error").show();
                  $("p .text-error").text("An error has occurred, reload the page and try again");
              }
      });
    }

    function Get_RevolvingCredit(customer_id, cart_total){

      $(".container-error").hide();
      $("p .text-error").empty();

      $.ajax({
          type: "GET",
          url: "https://facplnus.2becommerce.com/api/revolving_credit/customer/" + cust_id,
          success: function(result){
              if(result.data){

                  $(".container-error").hide();
                  $("p .text-error").empty();


                  if(result.data == undefined){

                      $(".cart-title-revolving-credit").hide();
                      $(".cart-title-total").removeClass("exceeded-limit");
                      $(".cart-checkout button").removeClass("disabled-btn").show();
                  }
                  else{

                      var format_cupo = Shopify.formatMoney(result.data, "");

                      $(".total-credit").empty().append(format_cupo);
                      $(".total-days").empty().append(result.days_due);
                    
                      if( (cart_total > result.data) || (result.days_due > 0) ){

                          $(".cart-title-revolving-credit").addClass("exceeded-limit").removeClass("ok-limit");
                          $(".cart-title-revolving-credit").show();
                          $(".cart-title-total").addClass("exceeded-limit");
                          $("svg.fa-exclamation-circle").hide();
                          $("svg.fa-exclamation-triangle").show();
                          $(".cart-checkout button").addClass("disabled-btn").hide();
                          $(".days-due").show();
                      }
                      else{
                          $(".cart-title-revolving-credit").addClass("ok-limit").removeClass("exceeded-limit");
                          $(".cart-title-revolving-credit").hide();
                          $(".cart-title-total").removeClass("exceeded-limit");
                          $("svg.fa-exclamation-circle").hide();
                          $("svg.fa-exclamation-triangle").hide();
                          $(".cart-checkout button").removeClass("disabled-btn").show();
                          $(".days-due").hide();
                      }
                  }
              }
              else{

                  $(".container-error").show();
                  $("p .text-error").text(JSON.stringify(result.error));
              }
          },
          error: function(data){

              console.log(data);
              $(".container-error").show();
              $("p .text-error").text("An error has occurred try again");
          },
          failure: function(errMsg) {
              console.log(errMsg);
              $(".container-error").show();
              $("p .text-error").text("An error has occurred, reload the page and try again");
          }
      });
    }

    

    $(document).ready(function () {
      	
      	$(".site-main").css("padding-top", $("#shopify-section-static-header").height());
      	$("#shopify-section-static-slideshow .slideshow").height( $(".slideshow-slide.is-selected").height() );
    	

    	
    	
      
    		$(".text-collection").insertBefore( $(".bc-sf-most-popular-products-wrapper.bc-sf-widget-slider-wrapper") );
      		
    	
        

    	$(".cart_form input[type=number].moq").on("click keyup change mousewheel", function(){
          
            var stock = $(this).data("stock");
          
            if(stock < 9999){
                var price = $(this).data("price");
                var current_val = $(this).val();
                var qty = stock - current_val;
              	
              	if( isNaN(current_val) || current_val ==""){
                	
                  	current_val = 0;

              	}
              	$(this).val(parseInt(current_val));

              	var elements = $(this).parents("form.cart_form").find("input[type=number].moq");
              	console.log(elements);
              	var items = 0;
              	var subt = 0;
              	for (var n = 0; n < elements.length; n++) {
                	
                  	subt += parseInt(elements[n].value) * parseInt(elements[n].dataset.price);
                	items += parseInt(elements[n].value);
              	}
              	var str = subt.toString();

              	var str2 = "<strong>Subtotal:</strong> $ " + str.substr(0, str.length -2) + "." + str.slice(-2);
              	$(this).parents("form.cart_form").find("#total").html(str2);
            }
          	else{
              
              	var elements = $(this).parents("form.cart_form").find("input[type=number].moq");
                var items = 0;
                var subt = 0;
              
                for (var n = 0; n < elements.length; n++) {
                  	
                  	subt += parseInt(elements[n].value) * parseInt(elements[n].dataset.price);
                  	items += parseInt(elements[n].value);
                }
                
              	var price = $(this).data("price");
                var current_val = $(this).val();
                
              	if( isNaN(current_val) || current_val ==""){
                  	
                  	current_val = 0;
                }
              
                $(this).val(parseInt(current_val));
                var itms = $(this).parents("form.cart_form").find("#items");
                var prod_moqs = 120 * contador;
                
              	console.log("prod_moqs:"+ prod_moqs);
                
              	if(items < prod_moqs){
                  	$(this).parents("form.cart_form").find(':input[type="submit"]').prop('disabled', true).hide();
                  	$(this).parents("form.cart_form").find('#submit_cart').prop('disabled', true);
                  	$(this).parents("form.cart_form").find("#items").text("Sorry your cart doesn't meet the minimun order quantity requirements, please complete the required units and then you can proceed to checkout.");
                  	if(!itms.hasClass("red")){
                      
                    	itms.addClass("red");
                  	}
                }
              	else{
                  	if( isNaN(items) || items ==""){
                    	
                      	items = 0;
                  	}
                    $(this).parents("form.cart_form").find(':input[type="submit"]').prop('disabled', false).show();
                    $(this).parents("form.cart_form").find('#submit_cart').prop('disabled', false);
                    $(this).parents("form.cart_form").find("#items").text("");
                    if(itms.hasClass("red")){
                    	itms.removeClass("red");
                  	}
                }
                var str = subt.toString();
               	/* $(this).parents("form.cart_form").find("#items").text("Items: "+items.toString());*/
                var str2 = "<strong>Subtotal:</strong> $ " + str.substr(0, str.length -2) + "." + str.slice(-2);
                $(this).parents("form.cart_form").find(".modal-foot #total").html(str2);
            }
    	});
      
            

   		$(".button-mujer a").click(function(e){
          
            $("#tab-mujer").addClass("show-tab");
            $("#tab-mujer").removeClass("none-tab");
            $(".button-mujer").addClass("active-link");
          
            $("#tab-hombre").removeClass("show-tab");
            $("#tab-hombre").addClass("none-tab");
            $(".button-hombre").removeClass("active-link");
          
            e.preventDefault();
      	});

      	$(".button-hombre a").click(function(e){
          
            $("#tab-hombre").addClass("show-tab");
            $("#tab-hombre").removeClass("none-tab");
            $(".button-hombre").addClass("active-link");
          
            $("#tab-mujer").removeClass("show-tab");
            $("#tab-mujer").addClass("none-tab");
            $(".button-mujer").removeClass("active-link");
          
            e.preventDefault();
      	});

      	alturasIguales(".row-products div a h3", 0);

      	$(".footer-contact-numbers").append($("#shopify-section-static-contact-numbers ul").clone());
      	$("#shopify-section-static-contact-numbers ul").insertAfter(".contact-numbers p");
    });

    $(document).on("load",function(){

      	var width_page = $(window).width();

        alturasIguales(".row-products div a h3", 0);
    });
    $(window).resize(function(){
		
      	$(".site-main").css("padding-top", $("#shopify-section-static-header").height());
      	alturasIguales(".row-products div a h3", 0);
  	});
	$(window).scroll(function() {
		
      	$(".site-main").css("padding-top", $("#shopify-section-static-header").height());
    });